import React from 'react';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';
import createParentChildArray from '../../../helpers/createParentChildArray';

import './style.scss';

interface ViewThemesOverviewProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyTheme>>;
}

const ViewThemesOverview: React.FC<ViewThemesOverviewProps> = ({
  entities,
}) => {
  const sortedParentChildEntities = createParentChildArray(
    entities.toJS() as unknown as TaxonomyTheme[],
  );

  return (
    <div className="ViewThemesOverview">
      <div className="row">
        {sortedParentChildEntities.map((entity) => {
          const taxonomy = entity.toJS();
          const parentTaxonomy = taxonomy.parent;

          const id = parentTaxonomy.tid[0].value;
          const uuid = parentTaxonomy.uuid[0].value;
          const langcode = parentTaxonomy.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <Taxonomy
              key={key}
              id={id}
              entity={entity.get('parent')}
              childrenEntities={entity.get('children')}
              viewMode="teaser"
              className="col-12 col-lg-6"
            />
          );
        })}
      </div>
    </div>
  );
};

export default ViewThemesOverview;
